<template>
  <div>
<!-- Overlay de carga -->
    <v-overlay :value="loading" absolute>
      <v-progress-circular
        indeterminate
        size="64"
      ></v-progress-circular>
    </v-overlay>
    <div class="ma-6">
      <hr class="mb-4" />
      <div v-if="formDataAvailable">
        <div class="font-weight-bold mb-5">
          {{ currentGroup.headerName }}
        </div>
        <form>
          <div v-for="(element, index) in currentGroupElements" :key="element.id">

            <div v-if="element.excluding && isFirstExcluding(index)" class="mt-4 mb-4">
              <RadioFormElement
                :elements="getElementsWithAnswers(excludingElements)"
                @answer-updated="updateAnswers"
                ref="formElements"
              />
            </div>

            <div v-else-if="!element.excluding">
              <component
                :is="getComponentType(element)"
                :element="getElementWithAnswer(element)"
                @answer-updated="updateAnswers"
                ref="formElements"
              />
            </div>

          </div>
        </form>
      </div>
    </div>

    <div class="footer-message pa-1">
      <v-row>
        <v-container class="py-0 fill-height">
          <v-row class="pt-4 px-1">
            <!-- Espacio izquierdo -->
            <div v-if="currentPageIndex < formGroups.length - 1" class="col-md-8"></div>

            <!-- Botón ANTERIOR -->
            <div class="col-md-2 col-6 links text-left">
              <v-btn
                class="footer-text-btn"
                v-if="currentPageIndex > 0"

                elevation="0"
                @click="prevPage"
              >
                <v-icon left>mdi-arrow-left</v-icon>
                {{ $t("signer_form.previous_button") }}
              </v-btn>
            </div>

            <!-- Botón SIGUIENTE -->
            <div class="col-md-2 col-6 links text-right">
              <v-btn
                class="footer-text-btn"
                v-if="currentPageIndex < formGroups.length - 1"

                elevation="0"
                :disabled="!isCurrentGroupFilled"
                @click="nextPage"
              >
                <v-icon left>mdi-arrow-right</v-icon>
                {{ $t("signer_form.next_button") }}
              </v-btn>
            </div>

            <!-- Espacio derecho -->
            <div v-if="currentPageIndex > 0" class="col-md-8"></div>
          </v-row>

          <!-- BOTÓN GUARDAR Y ENVIAR en la última página -->
          <div class="row" v-if="currentPageIndex === formGroups.length - 1">
            <div class="col-md-12 col-12 reject pr-0">
              <v-btn
                large
                class="footer-text-btn"
                block
                dark
                :disabled="!isCurrentGroupFilled"
                @click="submitAnswers"
              >
                {{ $t("signer_form.save_and_continue") }}
              </v-btn>
            </div>
          </div>
        </v-container>
      </v-row>
    </div>

    <v-snackbar v-model="submitError" :timeout="5000" color="red" variant="tonal">
      {{ submitErrorMessage }}
      <template v-slot:actions>
        <v-btn density="compact" icon="mdi-close" color="indigo" variant="text" @click="submitError = false" />
      </template>
    </v-snackbar>
  </div>
</template>



<script>
import InputFormElement from './shared/InputFormElement.component.vue';
import CheckboxFormElement from './shared/CheckboxFormElement.component.vue';
import RadioFormElement from './shared/RadioFormElement.component.vue';
import FormsService from '../services/forms-service.js';
import { mapGetters } from 'vuex';

export default {
  components: {
    InputFormElement,
    CheckboxFormElement,
    RadioFormElement
  },
  data() {
    return {
      answers: [],
      submitError: false,
      submitErrorMessage: null,
      token: null,
      authId: null,
      currentDocument: null,
      formToken: null,
      loading: false
    };
  },
  computed: {
    isCurrentGroupFilled() {
      const elements = this.currentGroupElements;
      if (!elements.length) return false;

      // 1. VALIDACIÓN DE INPUTS Y CHECKBOXES NORMALES
      // Filtramos solo los que NO son excluyentes
      const nonExcludingValid = this.nonExcludingElements.every(el => {
        const ans = this.answers.find(a => a.id === el.id);
        const currentAnswer = ans ? ans.answer : null;

        // Si es INPUT y es OBLIGATORIO, debe tener contenido
        if (el.signerFormElementType === 'INPUT' && el.mandatory) {
          return currentAnswer !== null && currentAnswer.toString().trim() !== '';
        }

        // Si no es obligatorio (o es un checkbox), es válido aunque no haya 'ans'
        return true;
      });

      // 2. VALIDACIÓN DEL GRUPO RADIO (EXCLUYENTES)
      // Si no hay elementos excluyentes, esta parte se da por válida (true)
      let excludingValid = true;
      if (this.excludingElements.length > 0) {
        // Es válido si al menos uno de los elementos del grupo Radio tiene answer: true
        excludingValid = this.excludingElements.some(el => {
          const ans = this.answers.find(a => a.id === el.id);
          return ans && ans.answer === true;
        });
      }

      // EL BOTÓN SE HABILITA SOLO SI AMBAS LÓGICAS CUMPLEN
      return nonExcludingValid && excludingValid;
    },

    // detecta si estamos en la última página
    isLastPage() {
        return this.currentPageIndex === this.formGroups.length - 1;
        },
    // comprueba la validez de TODOS los campos de la página actual
    isCurrentPageValid() {
    // si no es la última página devolvemos false para que el botón no aparezca
       if (!this.isLastPage) return false;
       // reutilizamos tu método de validación
        return this.checkValidation();
      },



    formDataAvailable() {
      return this.formGroups.length > 0;
    },
    currentGroup() {
        return this.formGroups && this.formGroups[this.currentPageIndex]
          ? this.formGroups[this.currentPageIndex].signerFormElement
          : {};
      },

    // Filtra los 5 elementos (Inputs/Checkboxes sueltos)
      nonExcludingElements() {
        return this.currentGroup.nonExcludingElements || [];
      },

      // Elementos que forman el grupo Radio
      // Filtra los 2 elementos que deben ser Radio Buttons
        excludingElements() {
          return this.currentGroup.excludingElements || [];
        },

    // Mantenemos esta para que el botón "Siguiente" siga validando todo el grupo
      currentGroupElements() {
        const group = this.currentGroup;
        if (!group) return [];

        // Combinamos respetando el orden del JSON (Excluyentes primero, luego el resto)
        const excluding = group.excludingElements || [];
        const nonExcluding = group.nonExcludingElements || [];

        return [...excluding, ...nonExcluding];
      },

    currentPageIndex() {
      return this.$store.state.forms.currentPageIndex;
    },
    formGroups() {
      return this.$store.state.forms.formData;
    },
    hasAssociation() {
      return this.$store.getters['common/hasAssociation'];
    },
    currentRoute() {
      return this.$route;
    },
    documentCheckList() {
      return localStorage.getItem("documentCheckList") ? JSON.parse(localStorage.getItem("documentCheckList")) : [];
    },
    getID() {
      return this.$route.params.id;
    },
    ...mapGetters('attachments', [
      'hasAttachments', 'getTransactionApiToken'
    ]),
    hasSignerForm() {
      return this.$store.getters['forms/hasSignerForm'];
    },
    hasPendingSignerForm() {
      return this.$store.getters['forms/hasPendingSignerForm'];
    }
  },
  methods: {
    isFirstExcluding(index) {
              // Busca el índice del primer elemento que tenga excluding: true
              const firstIndex = this.currentGroupElements.findIndex(el => el.excluding);
              return index === firstIndex;
            },

    async submitAnswers() {
      this.loading=true;
      await this.$nextTick();
      this.submitError = false;
      this.submitErrorMessage = null;

      let isFormValid = this.checkValidation();

      if (isFormValid) {

           // Ensure all form elements are included in the answers
          this.generateAnswerArray();

        // Ensure all checkboxes, radio buttons, and text inputs have a value
        this.answers.forEach(answer => {
            if (answer.signerFormElementType === 'CHECKBOX' && (answer.answer === null || answer.answer === undefined)) {
                answer.answer = false;
            } else if (answer.signerFormElementType === 'RADIO' && (answer.answer === null || answer.answer === undefined)) {
                answer.answer = false;
            } else if (answer.signerFormElementType === 'INPUT' && answer.answer === undefined) {
                answer.answer = null;
            }
        });

        try {
          let payload = {
            signerFormAnswerElements: this.answers
          };

          await FormsService.postAnswers(this.$route.params.id, payload, this.token, this.authId).then(() => {
            localStorage.setItem('formAnswers', JSON.stringify(this.answers)); // Save answers to localStorage
            this.loadFormStatus();
            if(localStorage.getItem("checkingForms")) {
              this.$router.push({ name: `${this.hasAssociation ? 'custom-' : ''}multiple-pdf`, params: { id: this.$route.params.id }, query: this.$route.query });
              this.$store.commit('forms/resetFormState');  // Reseteamos los valores de formulario en Vuex
            } else {
                if (localStorage.getItem('type') && ['ONETIME', 'ONETIMEWITHID'].includes(localStorage.getItem('type'))) {
                  this.$router.push({ name: `${this.hasAssociation ? 'custom-' : ''}pdf-viewer`, query: this.$route.query });
                } else {
                  this.$router.push({ name: `${this.hasAssociation ? 'custom-' : ''}show-document`, params: { id: this.$route.params.id }, query: this.$route.query });
                }
            }
          }).catch(error => {
            this.submitError = true;
            this.submitErrorMessage = error.response.data === 'Form already answered' ? this.$t("signer_form.already_submitted") : this.$t("signer_form.submission_error");
          });
        } catch (error) {
          this.submitError = true;
          this.submitErrorMessage = this.$t("signer_form.submission_error");
        }
      }
      this.loading = false;
    },
    updateAnswers(emittedAnswer) {
      if (emittedAnswer) {
        if (Array.isArray(emittedAnswer)) {
          emittedAnswer.forEach(answer => {
            this.storeAnswer(answer);
          });
        } else {
          this.storeAnswer(emittedAnswer);
        }

        console.log('Updated answers:', this.answers); // Debugging
      }
    },
    storeAnswer(emittedAnswer) {
      const answerIndex = this.answers.findIndex(answer => answer.id === emittedAnswer.id);

      if (answerIndex !== -1) {
        // OPCIÓN A (Recomendada): Usar splice para reemplazar el objeto completo
        // Esto dispara la reactividad en Vue 2 inmediatamente
        this.answers.splice(answerIndex, 1, {
          ...this.answers[answerIndex],
          answer: emittedAnswer.answer
        });
      } else {
        this.answers.push(emittedAnswer);
      }

      // Guardar en localStorage
      localStorage.setItem('formAnswers', JSON.stringify(this.answers));
    },

    prevPage() {
      localStorage.setItem('formAnswers', JSON.stringify(this.answers)); // Save current answers to localStorage
      this.$store.commit('forms/updateCurrentPage', this.currentPageIndex - 1);
    },
    nextPage() {
      let isFormValid = this.checkValidation();

      if (isFormValid) {
        localStorage.setItem('formAnswers', JSON.stringify(this.answers)); // Save current answers to localStorage
        this.$store.commit('forms/updateCurrentPage', this.currentPageIndex + 1);
      }
    },
    checkValidation() {
      let isFormValid = true;

      if (Array.isArray(this.$refs.formElements)) {
        this.$refs.formElements.forEach(formElement => {
          const isValid = formElement.validateField();
          if (!isValid) {
            isFormValid = false;
          }
        });
      } else {
        const isValid = this.$refs.formElements.validateField();
        if (!isValid) {
          isFormValid = false;
        }
      }

      return isFormValid;
    },

   getComponentType(element) {
     if (element.signerFormElementType === 'INPUT') {
       return 'InputFormElement';
     }
     // Cualquier otro elemento individual (que no sea excluyente)
     return 'CheckboxFormElement';
   },

    getElementWithAnswer(element) {
      const answer = this.answers.find(ans => ans.id === element.id);
      return {
        ...element,
        answer: answer !== undefined ? answer.answer : element.signerFormElementType === 'INPUT' ? null : false
      };
    },
    getElementsWithAnswers(elements) {
      if (!elements || !Array.isArray(elements)) return []; // Validación extra
      return elements.map(element => ({
        ...element,
        answer: this.answers.find(ans => ans.id === element.id)?.answer ?? (element.signerFormElementType === 'INPUT' ? null : false)
      }));
    },
    generateAnswerArray() {
      let elements = [];
      this.formGroups.forEach(groupData => {
        groupData.signerFormElement.excludingElements.forEach(element => {
          element.groupId = groupData.signerFormElement.id;
          elements.push(element);
        });

        groupData.signerFormElement.nonExcludingElements.forEach(element => {
          element.groupId = groupData.signerFormElement.id;
          elements.push(element);
        });
      });

          // Ensure all elements are present in the answers array with signerFormGroup
          this.answers = elements.map(element => {
            let answer = this.answers.find(ans => ans.id === element.id);
            if (!answer) {
                answer = {
                    id: element.id,
                    signerFormGroup: {
                        id: element.groupId
                    },
                    answer: element.signerFormElementType === 'INPUT' ? null : false,
                    signerFormElementType: element.signerFormElementType // Add the type for reference
                };
            } else if (!answer.signerFormGroup) {
                answer.signerFormGroup = {
                    id: element.groupId
                };
            }
            return answer;
        });


      // this.answers = elements.map(element => ({
      //   id: element.id,
      //   signerFormGroup: {
      //     id: element.groupId
      //   },
      //   answer: element.signerFormElementType === 'INPUT' ? null : false
      // }));
    },
    async findCurrentDocument() {
      try {
        await this.$store.dispatch('forms/getFormDetails', {
          requestId: this.$route.params.id,
          token: this.token,
          authId: this.authId
        });
        console.log('Form details loaded');
      } catch (error) {
        console.error('Error fetching form details:', error);
      }
    },
    async loadFormStatus() {
      try {
        const response = await this.$store.dispatch('forms/getFormStatus', {
          requestId: this.$route.params.id,
          token: this.token,
          authId: this.authId
        });
        console.log('Form Status Loaded:', response);
      } catch (error) {
        console.error('Error loading form status:', error);
      }
    },
    async loadQuestions() {
      try {
        const response = await this.$store.dispatch('forms/getFormStatus', {
          requestId: this.$route.params.id,
          token: this.token,
          authId: this.authId
        });
        console.log('Form Status Loaded:', response);
      } catch (error) {
        console.error('Error loading form status:', error);
      }
    }
  },
  async created() {

    this.token = this.$route.query.token || null;
    this.authId = this.$route.query.auth_id || null;
    this.loadFormStatus();
    this.loadQuestions();
    if (this.currentRoute && this.currentRoute.params.id && this.token) {
      await this.findCurrentDocument();
    }
    // this.answers = JSON.parse(localStorage.getItem('formAnswers')) || [];
  }
};
</script>
